import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import moment from "moment";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import TablaAsignacionFondoAvance from "./tablaAsignacionesFondoAvance";
import TablaDetalleFondoAvance from "./tablaDetalleFondoAvance";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, SearchInput, Select, Textarea } from "../../ui/inputs/Input";

export const ModalFondoAvance = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [habiBot, setHabiBot] = useState(false);
  const [habiCta, setHabiCta] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [operacionper, setOperacionper] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [persona, setPersona] = useState([]);
  const [datospre, setDatospre] = useState([]);
  const [anio, setAnio] = useState([]);
  const [valida, setValida] = useState(0);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [idCheemi] = useState(0);
  const [idCtaBan, setIdCtaBan] = useState("");
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [modifi1, setModifi1] = useState(false);
  const [proce1, setProce1] = useState(false);
  const [desde, setDesde] = useState(0);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [tabs, setTabs] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane",
    tab3: "tab-pane",
    tab4: "tab-pane",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtIdprov = useRef();
  const txtCodigo = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtConcepto = useRef();
  const txtIdCuenta = useRef();
  const txtNomBanco = useRef();
  const txtNumCuenta = useRef();
  const cmbTipo = useRef();
  const txtMonto = useRef();
  const txtCedula = useRef();
  const txtNombre = useRef();
  const txtApellido = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf = useRef();
  const txtCel = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const edad = parseInt(moment.utc(fechaSistema).format("YYYY")) - 18;
  const limiteEdad =
    edad + "-" + moment.utc(fechaSistema).format("MM-DD").toString();
  const onChange = (e) => {
    if (e.target.id === "anio") {
      /* if (e.target.value > anioactu) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡El Año no debe ser Mayor a los Anteriores!",
          icono: "error",
        });
      } else { */
        setAnio(e.target.value);
      /* } */
    } else if (e.target.id === "inputMotivo") {
      e.target.value = e.target.value.toUpperCase();
    }
  };
  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputNombres") {
        txtApellido.current.focus();
      } else if (event.target.id === "inputApellidos") {
        txtDireccion.current.focus();
      } else if (event.target.id === "inputDireccion") {
        txtEmail.current.focus();
      } else if (event.target.id === "inputEmail") {
        txtTlf.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputTlf") {
        txtCel.current.focus();
      } else if (event.target.id === "inputCel") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtIdprov.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un Proveedor",
        icono: "informacion",
      });
      sigue = false;
      txtIdprov.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Favor Ingrese una Descripción",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un Responsable",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    }
    if (sigue) {
      setBody({
        operacion: operacion,
        nid: operacion === 1 ? 0 : txtCodigo.current.value,
        fech: txtFecha.current.value,
        nro: operacion === 1 ? 0 : values.nrofondo,
        descr: txtConcepto.current.value,
        org: txtIdprov.current.value,
        mont:
          operacion === 1
            ? 0
            : txtMonto.current.value.replace(/\./g, "").replace(",", "."),
        resp: persona.cedula,
        operacionper: operacionper,
        cor: values.correoe,
        ctlf1: txtTlf.current.value,
        ctlf2: txtCel.current.value,
        ape: txtApellido.current.value,
        dir: txtDireccion.current.value,
        fnac: txtFechaNac.current.value,
        nac: cmbNacionalidad.current.value,
        nombres: txtNombre.current.value,
        sex: cmbSexo.current.value,
        efi: idefiscal,
        ntip: cmbTipo.current.value,
      });
      let msg = "";
      setDesde(0);
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar el fondo de avance?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Reversar el fondo de avance?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar el fondo de avance?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/fondoavanceact`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let msg = "";
          if (props.operacion === 1) {
            msg = "Se registro correctamente el fondo de avance";
          } else if (props.operacion === 2) {
            msg = "Se edito correctamente el fondo de avance";
          } else if (props.operacion === 3) {
            msg = "Se elimino correctamente el fondo de avance";
          }
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msg,
            icono: "exito",
          });
          props.onHideRenderizar();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const cancelar = () => {
    setTabs({
      tab1: "tab-pane fade show active",
      tab2: "tab-pane",
      tab3: "tab-pane",
      tab4: "tab-pane",
    });
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setTabs({
      tab1: "tab-pane fade show active",
      tab2: "tab-pane",
      tab3: "tab-pane",
      tab4: "tab-pane",
    });
    setValues({
      nrofondo: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });

    txtFecha.current.value = "";
    setPersona({});
    setDatospre([]);
    setActivate(false);
    setIdCtaBan("");
    setValida(0);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setAnio(0);
    setTituloapro("");
    setActivo(true);
    setModifi(false);
    setProce(false);
    setModifi1(false);
    setProce1(false);
    setHabiCta(false);
    setCambioDatos(false);
  };
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };
  const cerrarMensaje = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 8) {
      if (props.operacion === 1) {
        setDesde(2);
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
          icono: "confirmacion",
        });
      } else if (props.operacion === 2) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
          icono: "exito",
        });
      } else if (props.operacion === 3) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
          icono: "exito",
        });
      }
    }
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idprov") {
          txtIdprov.current.focus();
        } else if (event.target.id === "idcuenta") {
          txtIdCuenta.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const seleccionarProveedor = (codigo) => {
    setMostrar1(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            if (props.operacion === 1) {
              setHabiBot(false);
            } else {
              setHabiBot(true);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Proveedor/Beneficiario, No esta Registrado!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarPersona = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${
      op.conexion
    }/api/consulta/modeli?campos=${campos}&id=${parseInt(
      cedula
    )}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            setPersona(response.data);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡la persona, No esta Registrado!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const handleProveedor = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      }
    }
  };
  const handlePersona = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarPersona(event.target.value);
      }
    }
  };
  const changeProveedor = (event) => {
    event.preventDefault();
    setHabiBot(true);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setData([]);
    setDatospre([]);
    setIdCtaBan("");
    txtIdCuenta.current.value = "";
    txtNomBanco.current.value = "";
    txtNumCuenta.current.value = "";
    txtMonto.current.value = "";
  };
  const onTabs = (op) => (e) => {
    e.preventDefault();
    if (op === 1) {
      setTabs({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 2) {
      setTabs({
        tab2: "tab-pane fade show active",
        tab1: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 3) {
      setTabs({
        tab3: "tab-pane fade show active",
        tab1: "tab-pane",
        tab2: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 4) {
      setTabs({
        tab4: "tab-pane fade show active",
        tab1: "tab-pane",
        tab3: "tab-pane",
        tab2: "tab-pane",
      });
    }
  };
  const aceptarPersona = (
    cedula,
    nombres,
    apellidos,
    correoe,
    tlf1,
    tlf2,
    fnacimiento,
    nacionalidad,
    sexo,
    direccion
  ) => {
    setPersona({
      cedula,
      nombres,
      apellidos,
      correoe,
      tlf1,
      tlf2,
      fnacimiento,
      nacionalidad,
      sexo,
      direccion,
    });
    setMostrar(false);
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setModifi(false);
        setModifi1(false);
        if (props.operacion !== 1) {
          setOperacionper(0);
          setValues(props.values);
          seleccionarProveedor(props.values.idorganismo);
          seleccionarPersona(props.values.responsable);
        } else {
          onTabs(1);
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          setOperacionper(0);
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 text-light fw-bold m-0">
          {operacion === 1
            ? "Registrar Fondo en Avance"
            : operacion === 2
            ? "Reversar Fondo en Avance"
            : operacion === 3
            ? "Eliminar Fondo en Avance"
            : "Consultar Fondo en Avance"}
        </h3>
        <button onClick={cancelar} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div >
          <ul className="nav nav-tabs" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                onClick={onTabs(1)}
                className="nav-link active"
                id="tab1"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#div1"
                role="tab"
                aria-controls="div1"
                aria-selected="true"
              >
                Datos del Fondo en Avance
              </a>
            </li>
            {operacion !== 1 ? (
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(2)}
                  className="nav-link"
                  id="tab2"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div2"
                  role="tab"
                  aria-controls="div2"
                  aria-selected="false"
                >
                  Asignaciones del Fondo en Avance
                </a>
              </li>
            ) : (
              ""
            )}
            {operacion !== 1 ? (
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(3)}
                  className="nav-link"
                  id="tab3"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div3"
                  role="tab"
                  aria-controls="div3"
                  aria-selected="false"
                >
                  Detalle del Fondo de Avance
                </a>
              </li>
            ) : (
              ""
            )}
          </ul>
          <div className="tab-content py-1" id="myTabContent">
            <div
              className={tabs.tab1}
              id="div1"
              role="tabpanel"
              aria-labelledby="tab1"
            >
              <fieldset className="col-12 p-0 m-0 d-flex flex-wrap gap-2">
                <div className="col-12 p-0 m-0 d-flex flex-wrap">
                  <div className="col-6 col-lg-2 p-0 pr-2 pr-lg-2 m-0">
                    <Input
                      label="Código:"
                      name="observacion"
                      disabled={true}
                      defaultValue={
                        values && values.idfondo ? values.idfondo : ""
                      }
                      id="inputDireccion"
                      ref={txtCodigo}
                    />
                  </div>
                  <div className="col-6 col-lg-4 p-0 m-0">
                    <Select
                      label="Tipo de Fondo:"
                      name="idestado"
                      defaultValue={
                        values && values.tipofondo ? values.tipofondo : ""
                      }
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      id="inputFechaReg"
                      options={[
                        { value: 0, label: "Fondo en Avence" },
                        { value: 1, label: "Fondo en Anticipo" },
                      ]}
                      ref={cmbTipo}
                    />
                  </div>
                  <div className="col-6 col-lg-3 m-0 mt-2 mt-lg-0 p-0 pr-2 pr-lg-0 pl-lg-2">
                    <Input
                      label="Fecha:"
                      type="date"
                      defaultValue={
                        values && values.fecha
                          ? moment.utc(values.fecha).format("YYYY-MM-DD")
                          : ""
                      }
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      id="inputDireccion"
                      ref={txtFecha}
                    />
                  </div>
                </div>

                <fieldset className="col-12 p-2 m-0 border-azul rounded d-flex flex-wrap justify-content-between">
                  <div className="col-6 col-lg-2 m-0 p-0">
                    <SearchInput
                      label="Código:"
                      autoComplete="off"
                      onChange={changeProveedor}
                      onKeyUp={handleProveedor}
                      onBlur={handleInputNumChange}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      id="idprov"
                      disabledButton={
                          operacion === 4 || operacion === 2 || operacion === 3
                          ? true
                          : false
                        }
                        onClickButton={() => setMostrar1(true)}
                        ref={txtIdprov}
                    />
                  </div>
                  <div className="col-6 col-lg-3 m-0 p-0 pl-2 px-lg-2">
                    <Input label = 'RIF:'
                      maxLength={12}
                      disabled={true}
                      id="inputDireccion"
                      ref={txtCedurifprov}
                    />
                  </div>
                  <div className="col-12 col-lg-6 m-0 mt-2 mt-lg-0 p-0">
                    <Input label = 'Nombre:'
                      disabled={true}
                      id="inputDireccion"
                      ref={txtNombreprov}
                    />
                  </div>
                </fieldset>

                <div className="col-12 m-0 p-0">
                  <Textarea label = 'Descripción:'
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    style={{ height: 70 }}
                    name="observacion"
                    onChange={onChange}
                    defaultValue={
                        values && values.descripcion
                        ? values.descripcion.trim()
                        : ""
                    }
                    placeholder="Descripción de la Descripción"
                    id="inputDireccion"
                    ref={txtConcepto}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 ml-auto p-0">
                  <Input label = 'Monto:'
                    disabled={true}
                    defaultValue={
                        values && values.monto
                        ? formatMoneda(
                            values.monto
                            .toString()
                              .replace(",", "")
                              .replace(".", ","),
                              ",", ".", 2
                        )
                        : ""
                    }
                    placeholder="0,00"
                    id="inputDireccion"
                    ref={txtMonto}
                  />
                </div>

                <fieldset className="col-12 border-azul rounded m-0 p-2 d-flex flex-wrap justify-content-between">
                  <legend className="float-none m-0 w-auto fs-6 fw-bold">
                    Responsable
                  </legend>
                  {/* Cedula */}
                  <div className="col-6 col-lg-3 m-0 p-0 d-flex">
                    <Select label = 'Cedula:'
                      defaultValue={
                          persona && persona.nacionalidad
                          ? persona.nacionalidad.trim()
                          : ""
                      }
                      disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        id="inputNac"
                        options={[
                            {value:'V', label: 'V'},
                            {value:'J', label:'J'},
                            {value:'E', label:'E'}
                        ]}
                        ref={cmbNacionalidad}
                    />
                    <SearchInput
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      autoComplete="off"
                      onKeyUp={handlePersona}
                      onBlur={handlePersona}
                      defaultValue={
                        persona && persona.cedula ? persona.cedula.trim() : ""
                      }
                      id="inputCedula"
                      disabledButton={
                        operacion === 4 || operacion === 2 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClickButton={() => setMostrar(true)}
                      ref={txtCedula}
                      />
                  </div>
                  <div className="d-none d-lg-flex col-3 m-0 p-0"></div>
                  <div className="col-6 col-lg-2 p-0 pl-2 pl-lg-0 m-0 ">
                    <Select label = 'Sexo:'
                      disabled={operacionper === 1 ? false : true}
                      defaultValue={
                          persona && persona.sexo ? persona.sexo.trim() : ""
                        }
                        id="inputSexo"
                        options={[
                          { value: "M", label: "M" },
                          { value: "F", label: "F" }
                        ]}
                        ref={cmbSexo}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 mt-2 mt-lg-0 p-0 pl-lg-2">
                    <Input label = 'Fecha Nacimiento:'
                      type="date"
                      disabled={operacionper === 1 ? false : true}
                      max={limiteEdad}
                      defaultValue={
                          persona && persona.fnacimiento
                          ? persona.fnacimiento !== ""
                            ? moment.utc(persona.fnacimiento).format("YYYY-MM-DD")
                            : ""
                            : ""
                        }
                        id="inputFnac"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                        onChange={onChange}
                        ref={txtFechaNac}
                        />
                  </div>
                  <div className="col-12 col-lg-4 m-0 mt-2 p-0">
                    <Input label = 'Telefono:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona && persona.tlf1
                          ? persona.tlf1 !== ""
                            ? persona.tlf1.trim()
                            : ""
                          : ""
                      }
                      id="inputTlf"
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                      onChange={onChange}
                      ref={txtTlf}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 mt-2 p-0 px-lg-2">
                    <Input label = 'Celular:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona && persona.tlf2
                          ? persona.tlf2 !== ""
                            ? persona.tlf2.trim()
                            : ""
                          : ""
                      }
                      id="inputCel"
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                      onChange={onChange}
                      ref={txtCel}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 mt-2 p-0">
                    <Input label = 'E-mail:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona
                          ? persona.correoe !== ""
                          ? persona.correoe
                            : ""
                            : ""
                        }
                        id="inputEmail"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                        onChange={onChange}
                        ref={txtEmail}
                    />
                  </div>
                  <div className="col-12 col-lg-6 p-0 m-0 mt-2">
                    <Input label = 'Nombres:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona && persona.nombres
                          ? persona.nombres !== ""
                          ? persona.nombres.trim()
                            : ""
                          : ""
                        }
                      id="inputNombres"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                      onChange={onChange}
                      ref={txtNombre}
                    />
                  </div>
                  <div className="col-12 col-lg-6 m-0 mt-2 p-0 pl-lg-2">
                    <Input label = 'Apellidos:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona && persona.apellidos
                          ? persona.apellidos !== ""
                            ? persona.apellidos.trim()
                            : ""
                          : ""
                        }
                        id="inputApellidos"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                        onChange={onChange}
                        ref={txtApellido}
                    />
                  </div>
                  <div className="col-12 m-0 mt-2 p-0">
                    <Input label = 'Dirección:'
                      disabled={operacionper === 1 ? false : true}
                      autoComplete="off"
                      defaultValue={
                          persona && persona.direccion
                          ? persona.direccion !== ""
                            ? persona.direccion.trim()
                            : ""
                          : ""
                      }
                      id="inputDireccion"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                      onChange={onChange}
                      ref={txtDireccion}
                    />
                  </div>
                </fieldset>
              </fieldset>
            </div>
            <div
              className={tabs.tab2}
              id="div2"
              role="tabpanel"
              aria-labelledby="tab2"
            >
              <TablaAsignacionFondoAvance
                renderAsig={props.renderAsig}
                operacion={operacion}
                idfondo={values.idfondo}
                asignacion={props.asignacion}
              />
            </div>
            <div
              className={tabs.tab3}
              id="div3"
              role="tabpanel"
              aria-labelledby="tab3"
            >
              <TablaDetalleFondoAvance detalles={props.detalles} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." ? cerrarModal() : cerrarMensaje();
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (desde === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Egreso Nª" + idCheemi + " fué Registrado Correctamente",
              icono: "exito",
            });
          }
        }}
        onHideSi={handleCloseSi}
      />
      <CatalogoPersona
        show={mostrar}
        onHideCancelaCatPer={() => setMostrar(false)}
        onHideAceptaCatPer={aceptarPersona}
      />
      <CatalogoProveedor
        show={mostrar1}
        onHideCancelaCatProv={() => setMostrar1(false)}
        imp={1}
        onHideAceptaCatProv={seleccionarProveedor}
      />
    </Modal>
  );
};
